<template>
  <Modal
    :open="openAuthModal"
    @closePopup="closeModal"
    class="auth"
  >
    <div class="auth-modal">
      <tabs ref="forgotPass">
        <tab :name="$t('auth.logIn')" :selected="true" width="400">
          <Login @closeAuthModal="closeModal" @forgotPassword="forgotPasswordFunc" @RegisterFunc="RegisterFunc" />
        </tab>
        <tab :name="$t('auth.register')" width="700">
          <Registration @closeAuthModal="closeModal" :referral="referral"  @LoginFunc="LoginFunc"/>
        </tab>
        <tab name="" width="700">
          <ForgotPassword :token="resetPasswordToken" @setLogin="setLogin" />
        </tab>
      </tabs>
    </div>
  </Modal>
</template>

<script>
import ForgotPassword from '../auth/ForgotPassword.vue'
import Login from '../auth/Login.vue'
import Registration from '../auth/Registration.vue'
import Modal from '../Modal.vue'
import Tab from '../tabs/Tab.vue'
import Tabs from '../tabs/Tabs.vue'
export default {
  components: { ForgotPassword, Tabs, Tab, Login, Registration, Modal },
  props: {
    openAuthModal: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      referral: '',
      resetPasswordToken: ''
    }
  },

  mounted() {
    this.checkIfReferral()
    this.checkIfRedirectLogin()
    this.setSuccessRegistration()
    this.resetPassword()
  },

  methods: {
    setLogin() {
      this.$refs.forgotPass.setTab({ name: this.$t('auth.logIn'), width: 400 })
    },
    checkIfReferral() {
      if (this.$route.query.show_registration_modal) {
        this.$store.dispatch('openAuthModal', true)
        this.$nextTick(() => {
          this.$refs.forgotPass.setTab({ name: this.$t('auth.register'), width: 700 })
        })
        this.referral = this.$route.query.ref
      }
    },
    checkIfRedirectLogin() {
      if (this.$route.query.show_login_modal) {
        this.$store.dispatch('openAuthModal', true)
        this.$nextTick(() => {
          this.$refs.forgotPass.setTab({ name: this.$t('auth.logIn'), width: 400 })
        })
        this.referral = this.$route.query.ref
      }
    },
    closeModal() {
      this.$emit('update:openAuthModal', false)
    },
    forgotPasswordFunc() {
      this.$refs.forgotPass.setTab({ name: '', width: 700 })
    },
    RegisterFunc() {
      this.$refs.forgotPass.setTab({ name: this.$t('auth.register'), width: 700 })
    },
    LoginFunc() {
      this.$refs.forgotPass.setTab({ name: this.$t('auth.logIn'), width: 400 })
    },
    setSuccessRegistration() {
      this.$nextTick(() => {
        if (this.$route.query.success_registration) {
          this.$store.dispatch('setSuccessRegistration', true)
        }
      })
    },
    resetPassword() {
      this.$nextTick(async () => {
        const token = this.$route.query.token
        if (token) {
          await this.$store.dispatch('openAuthModal', true)
          this.$refs.forgotPass.setTab({ name: '', width: 400 })
          try {
            const res = await this.$api.user.validateToken(token)
            if (!res) return
            this.resetPasswordToken = token
            // this.$refs.forgotPass.setTab({ name: '', width: 400 })
          } catch (e) {
            this.$store.dispatch('updateModalStatus', {
              status: true,
              name: 'error',
              message: e
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/modals/auth_modal.scss';
</style>



// WEBPACK FOOTER //
// src/components/modal/AuthModal.vue